/**
 * `TyosuhteenPaattaminenRoute` — slug-pinned re-export of
 * `ArticleDetailPage` for the `/tyosuhteen-paattaminen` proto-equivalent
 * URL (TA21).
 *
 * The article is a clean lift (no bespoke chrome) per
 * `phase-a-content-inventory.md`'s "Lift posture" table; rendering it
 * through the generic `ArticleDetailPage` with a pinned slug keeps the
 * route surface aligned with the proto's URL shape while reusing the
 * same skeleton / not-found / error / sanitised-body contract every
 * other Phase A article-detail surface honours.
 *
 * The slug pin uses `ArticleDetailPage`'s optional `slug` prop (TA21
 * added it precisely for this re-export pattern); no nested router
 * context is faked. See `ArticleDetailPage.tsx`'s file header for the
 * prop-vs-param resolution contract.
 */

import type { JSX } from 'react';

import { ArticleDetailPage } from './ArticleDetailPage.js';

export function TyosuhteenPaattaminenRoute(): JSX.Element {
  return (
    <ArticleDetailPage
      slug="tyosuhteen-paattaminen"
      analyticsPageKey={{ kind: 'memberRoute', route: 'employment-termination' }}
    />
  );
}
